import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Menubar } from 'primereact/menubar';
import { PageRequestError } from 'components/PageRequestError';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const PaytranvwListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, sortBy, sortOrder, apiRequestError, getPageBreadCrumbs, onSort, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { limit } =  pagination;
	// return sum of payment for the current records
	const totalPayment = utils.sum(records, 'payment');
	function ActionButton(data){
		const items = [
		{
			label: $t('payNow'),
			command: (event) => { app.navigate(`/paytranvw`) },
			icon: "pi pi-clone"
		}
	]
		return (<Menubar className="p-0 " model={items} />);
	}
	function PaydateTemplate(data){
		if(data){
			return (
				<>{utils.humanDate( data.paydate )}</>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
// AC Code options for dropdown
const acCodeOptions = [
{ label: 'CASH', value: 'CASH' },
{ label: 'BANK', value: 'BANK' }
];
// State to track payment inputs for each row
const [paymentInputs, setPaymentInputs] = useState({});
// Handle payment input change
const handlePaymentChange = (amortid, value) => {
    setPaymentInputs(prev => ({
        ...prev,
        [amortid]: {
            ...prev[amortid],
            amount: value
        }
    }));
};
// Handle AC code change
const handleAcCodeChange = (amortid, value) => {
    setPaymentInputs(prev => ({
        ...prev,
        [amortid]: {
            ...prev[amortid],
            ac_code: value
        }
    }));
};
// Payment template with input field and dropdown
function PaymentTemplate(data) {
    if (!data) return null;
    const amortid = data.amortid;
    // Get current values from state or from data
    const currentAmount = paymentInputs[amortid]?.amount !== undefined 
    ? paymentInputs[amortid]?.amount 
    : data.payment || '';
    const currentAcCode = paymentInputs[amortid]?.ac_code !== undefined
    ? paymentInputs[amortid]?.ac_code
    : data.ac_code || 'CASH';
    return (
    <div className="flex flex-column gap-2">
    <div className="p-inputgroup">
    <InputText 
    value={currentAmount}
    onChange={(e) => handlePaymentChange(amortid, e.target.value)}
    className="w-full p-inputtext-sm"
    type="number"
    min="0"
    step="0.01"
    placeholder="Enter payment amount"
    />
    </div>
    <Dropdown
    value={currentAcCode}
    onChange={(e) => handleAcCodeChange(amortid, e.value)}
    options={acCodeOptions}
    placeholder="Select AC Code"
    className="w-full p-inputtext-sm"
    />
    </div>
    );
}
// REMOVE the first ActionButton function and keep only this one:
function ActionButton(data) {
    const amortid = data.amortid;
    const paymentData = paymentInputs[amortid] || {};
    const paymentAmount = paymentData.amount !== undefined ? paymentData.amount : data.payment;
    const acCode = paymentData.ac_code || data.ac_code || 'CASH';
    const payNow = async () => {
        if (!paymentAmount || paymentAmount <= 0) {
            app.flashMsg($t('error'), 'Please enter a valid payment amount', 'error');
            return;
        }
        try {
            const payload = {
                amortid: data.amortid,
                loanaccountno: data.loanaccountno,
                groupid: data.groupid,
                payment: paymentAmount,
                ac_code: acCode,
                paydate: data.paydate,
                empcode_collection: data.empcode_collection,
                branchcode: data.branchcode,
                userid: auth.userId,
                period: data.period
            };
            const response = await fetch(
            `${process.env.REACT_APP_API_PATH}loan/paynow`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${auth.token}`
                },
                body: JSON.stringify(payload)
            }
            );
            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.message || 'Payment failed');
            }
            app.flashMsg($t('success'), $t('paymentSuccess'));
            // Clear the input for this row after successful payment
            setPaymentInputs(prev => {
                const newInputs = { ...prev };
                delete newInputs[amortid];
                return newInputs;
            });
            pageController?.reload?.();
            } catch (err) {
            app.flashMsg($t('error'), err.message, 'error');
        }
    };
    const items = [
    {
        label: $t('payNow'),
        icon: 'pi pi-money-bill',
        command: payNow,
        visible: () => auth.canView('grouploantransaction/add')
    }
    ].filter(item => item.visible ? item.visible() : true);
    return <Menubar className="p-0" model={items} />;
}
// AC Code template for display only (not editable)
function AcCodeDisplayTemplate(data) {
    if (!data) return null;
    const amortid = data.amortid;
    const currentAcCode = paymentInputs[amortid]?.ac_code !== undefined
    ? paymentInputs[amortid]?.ac_code
    : data.ac_code || '';
    return <span>{currentAcCode}</span>;
}
	return (
<main id="PaytranvwListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('payTransaction')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-12 md:col-3 " >
                    <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                    </span>
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <FilterTags filterController={filterController} />
                    <div >
                        <PageBreadcrumbs />
                        <div className="page-records">
                            <DataTable 
                                lazy={true} 
                                loading={loading} 
                                value={records} 
                                dataKey="amortid" 
                                sortField={sortBy} 
                                sortOrder={sortOrder} 
                                onSort={onSort}
                                className=" p-datatable-sm" 
                                stripedRows={true}
                                showGridlines={false} 
                                rowHover={true} 
                                responsiveLayout="stack" 
                                emptyMessage={<EmptyRecordMessage />} 
                                >
                                {/*PageComponentStart*/}
                                <Column  field="amortid" header={$t('amortid')}   ></Column>
                                <Column  field="loanaccountno" header={$t('loanAccountno')}   ></Column>
                                <Column  field="membername" header={$t('memberName')}   ></Column>
                                <Column  field="groupid" header={$t('groupid')}   ></Column>
                                <Column  field="period" header={$t('period')}   ></Column>
                                <Column  field="paydate" header={$t('paydate')} body={PaydateTemplate}  ></Column>
                                <Column  field="payment" header={$t('payment')} body={PaymentTemplate}  ></Column>
                                <Column  field="empcode_collection" header={$t('empcode')}   ></Column>
                                <Column  field="branchcode" header={$t('branchcode')}   ></Column>
                                <Column  field="paid" header={$t('paid')}   ></Column>
                                <Column  field="ac_code" header={$t('acCode')} body={AcCodeDisplayTemplate}  ></Column>


                                <Column headerStyle={{width: 'auto'}} headerClass="text-center" body={ActionButton}></Column>
                                {/*PageComponentEnd*/}
                            </DataTable>
                            <div className="flex justify-content-around font-bold p-3">
                                <div>Total Payment : <Chip label={totalPayment} /></div>
                            </div>
                        </div>
                        <PageFooter />
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
	);
}
PaytranvwListPage.defaultProps = {
	primaryKey: '',
	pageName: 'paytranvw',
	apiPath: 'paytranvw/index',
	routeName: 'paytranvwlist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: false,
	importData: false,
	keepRecords: false,
	multiCheckbox: false,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10000,
}
export default PaytranvwListPage;
